module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Agenda.e805d463-ps.jpg";